import {NgModel} from 'model/ngModel';

export const Service = NgModel.extend({
    _name: 'VerticalService',
});
